import { DeepPartial, InstallGeneratorPackage } from 'types';

import { api } from './api';

export const installGeneratorPackageApi = api.injectEndpoints({
  endpoints: (build) => ({
    saveInstallGeneratorPackage: build.mutation<
      any,
      { accountId: string; savePackage: DeepPartial<InstallGeneratorPackage> }
    >({
      query: ({ accountId, savePackage }) => ({
        url: `v2/accounts/${accountId}/install-package/generator/save`,
        method: 'POST',
        body: { ...savePackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
      ],
    }),
    submitInstallGeneratorPackage: build.mutation<
      any,
      { accountId: string; installPackage: InstallGeneratorPackage }
    >({
      query: ({ accountId, installPackage }) => ({
        url: `v2/accounts/${accountId}/install-package/generator/submit`,
        method: 'POST',
        body: { ...installPackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
      ],
    }),
  }),
});

export const { useSaveInstallGeneratorPackageMutation, useSubmitInstallGeneratorPackageMutation } =
  installGeneratorPackageApi;
